/*document.addEventListener('DOMContentLoaded', function() {
    // Your code here
    let quickAdds = document.querySelectorAll('.grid-product__quick-add');
    quickAdds.forEach(function(quickAdd) {
        quickAdd.addEventListener('click', async (e) => {
            e.preventDefault();
            quickAdd.classList.add('btn--loading');
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: quickAdd.dataset.id,
                    quantity: 1
                })
            })
            .then(response => response.json())
            quickAdd.classList.remove('btn--loading');
        });
    });
});*/
jQuery('.grid-product__quick-add').click(function(){
    var id = jQuery(this).attr('data-id');
    var q = 1;
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: "quantity=" + q + "&id=" + id,
        dataType: 'json',
        success: function(cart) {
            setTimeout(function(){
              var cart = new theme.CartDrawer
              cart.init()
              cart.open();
            },1550);
        },
        error: function(XMLHttpRequest, textStatus) {
            alert("This Product is Sold Out");
        },
    });
});

function fnopenFaq() {
    // Trigger click event on element with ID 'whatinthebox'
    var element = document.getElementById('whatinthebox');
    if (element) {
      element.click();
      var offset = 180; // Adjust the offset as needed
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition - offset;
      window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
      });
    }
}

function fbnRediect(id){
  var element = document.getElementById(id);
  if (element) {
    var offset = 500; // Adjust the offset as needed
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
  }
}

//===========================slider_with_text========================//

jQuery(document).ready(function() {
  jQuery('.feature-row__first-image').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
  });
});


jQuery(document).ready(function() {
  resizeBox();
});
function resizeBox(){
  let lengthArr = [];
  jQuery('.featured-collection-ss .grid-product__title').each(function() {
    const height = jQuery(this).height();
    lengthArr.push(height);
  });
  const maxValue = Math.round(Math.max.apply(Math, lengthArr));
  jQuery('.featured-collection-ss .grid-product__title').each(function() {
    jQuery(this).css('--title-height', maxValue + 'px');
  });
}
jQuery(window).on('resize', function () {
  resizeBox();
});

jQuery(document).ready(function() {
  getReviewHeight();
});
function getReviewHeight(){
  let reviewHeight = [];
  jQuery('.featured-collection-ss .okendo-reviews').each(function() {
    const height3 = jQuery(this).height();
    reviewHeight.push(height3);
  });
  const maxValue = Math.round(Math.max.apply(Math, reviewHeight));
  jQuery('.featured-collection-ss .okendo-reviews').each(function() {
    jQuery(this).css('--review-height', maxValue + 'px');
  });
}
jQuery(window).on('resize', function () {
  getReviewHeight();
});


jQuery(document).ready(function() {
  getPriceHeight();
});
function getPriceHeight(){
  let classPriceHeight = [];
  jQuery('.featured-collection-ss .grid-product__price').each(function() {
    const height2 = jQuery(this).height();
    classPriceHeight.push(height2);
  });
  const maxValue = Math.round(Math.max.apply(Math, classPriceHeight));
  jQuery('.featured-collection-ss .grid-product__price').each(function() {
    jQuery(this).css('--price-height', maxValue + 'px');
  });
}
jQuery(window).on('resize', function () {
  getPriceHeight();
});

document.addEventListener("DOMContentLoaded", function() {
  var titleElement = document.querySelector("h1.product-single__title");
  if (titleElement) {
    var productName = titleElement.textContent.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
    document.body.classList.add(productName);
  }
});
